module.exports = __webpack_public_path__ + "img/9788949120690.a3ab9f34.jpg";